import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameMutationKeys } from '../../../keys'
import { UpdateGameTypeRequest, UpdateGameTypeResponse } from '../../../type'
import { updateGameType } from '../../services'

interface UpdateGameTypeParams {
	id: string
	payload: UpdateGameTypeRequest
}

export default function useMutationUpdateGameType(
	props?: UseBaseMutationOptions<UpdateGameTypeResponse, UpdateGameTypeParams>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.UpdateGameType],
		mutationFn: (params) => updateGameType(params.payload, params.id),
		...props,
	})
}
